import {getUseSharedState} from '~/utils/getUseSharedState'

export const useCurrentAudioTime = getUseSharedState(0)

export const seekAudioDispatcher = getUseSharedState(0)
